import React from "react";
import "./styles/Footer.scss";
import { ReactComponent as Logo } from "../assets/logo_simple.svg";
import { menuList } from "../utils/menu";
import { useTranslation } from "react-i18next";
import { useLangNavigate } from "../hooks/useLangNavigate";
const Footer = () => {
  const { t } = useTranslation();
  const langNavigate = useLangNavigate();
  const handleDownload = (path: string) => {
    window.location.href = path;
  };
  const openPdf = () => {
    window.open("https://pimfile.architeco-geo.synology.me/homepage/회사소개서_(주)아키테코그룹_(주)지오디엔티.pdf", "_blank");
  };
  return (
    <>
      <footer id="footer">
        <div className="inner">
          <div className="sitemap_wrap">
            {menuList.map((menu: { title: string; list: { name: string; link: string }[] }, index: number) => {
              return (
                <div className="sitemap" key={`${menu.title}_${index}`}>
                  <div className="title">{t(menu.title)}</div>
                  <ul>
                    {menu.list.map((li: { name: string; link: string }, index2: number) => {
                      return (
                        <li key={`${li.name}_${index2}`}>
                          <span
                            onClick={() => {
                              langNavigate(menuList[index].list[index2].link);
                            }}
                          >
                            {t(li.name)}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
          <div className="office_info_wrap">
            <div className="logo_wrap">
              <Logo className="logo" />
            </div>
            <div className="info_wrap">
              <div className="info">
                <span>{t("footer.corporateName")}</span>
                <span>{t("footer.ceo")}</span>
                <span>{t("footer.businessNumber")}</span>
              </div>
              <div className="info">
                <span>{t("footer.address")}</span>
                <span>{t("footer.email.label")}</span>
              </div>
            </div>
            <div className="btn_wrap">
              <div className="btn">
                <div className="img_box">
                  <img src="/imgs/icon_brochure.png" alt="brochure_icon" />
                </div>
                <span>{t("footer.download.label")}</span>
                <button onClick={openPdf}>{t("footer.download.download")}</button>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
